import _ from 'lodash';
import moment from 'moment';
import { format } from 'date-fns';
import { getClientConfigData } from 'src/workspace/utils';

export const getThisWeekRange = () => {
  const today = new Date();
  const day = today.getDay();
  const sunday = new Date(today);
  sunday.setDate(today.getDate() - day);
  sunday.setHours(0, 0, 0, 0);

  const saturday = new Date(sunday);
  saturday.setDate(sunday.getDate() + 6);
  saturday.setHours(23, 59, 59, 999);

  return [sunday, saturday] as [Date, Date];
};

export const sectionizeResults = (results, start, end) => {
  const sectionMap = {};
  const lang = 'en';

  let current = moment(end).locale(lang).clone();
  const startDate = moment(start).locale(lang).clone();

  while (current.isSameOrAfter(startDate, 'day')) {
    const key = current.format('YYYY-MM-DD');
    sectionMap[key] = {
      date: current.clone(),
      rows: [],
    };
    current = current.clone().subtract(1, 'day');
  }

  results.forEach((item) => {
    const meetingDate = item?.meeting?.date;
    if (!meetingDate) return;

    const id = moment(meetingDate).locale(lang).format('YYYY-MM-DD');

    if (sectionMap[id]) {
      const category = item?.calendar_item?.category;
      const isSummary = category === 'SUMMARY_CALENDAR_ITEM';

      if (isSummary) {
        sectionMap[id].rows.unshift(item);
      } else {
        sectionMap[id].rows.push(item);
      }
    }
  });

  return sectionMap;
};

export const getTodayActivity = (groupedActivities) => {
  const now = new Date();
  const todayId = format(now, 'yyyy-MM-dd');

  const todayGroup = groupedActivities.find(
    (g) => format(g.date, 'yyyy-MM-dd') === todayId,
  );

  if (!todayGroup) return false;
  if (todayGroup.activities.length === 0) return 'todayAvailable';

  const todaysMeetings = todayGroup.activities;

  const upcoming = todaysMeetings.filter(
    (act) => new Date(act.meeting.date).getTime() > now.getTime(),
  );

  return upcoming.length > 0
    ? upcoming[0]
    : todaysMeetings[todaysMeetings.length - 1];
};

export const getLeadNextStates = (lead) => {
  const config = getClientConfigData();
  const allStateChanges = _.get(config, 'state_changes');
  const states = _.get(config, 'states', []);
  return lead?.next_states
    ? lead.next_states
    : states.filter(
        (s) =>
          allStateChanges[lead.last_update_type] &&
          allStateChanges[lead.last_update_type].indexOf(s.code) > -1,
      );
};

export const getTransformedRevyreActivities = (revyreActivities) =>
  revyreActivities.map(({ mutatedEntity }) => ({
    code: mutatedEntity.id,
    meeting: {
      date: mutatedEntity?.scheduleMeeting?.start,
      duration:
        Number(mutatedEntity?.scheduleMeeting?.end) -
        Number(mutatedEntity?.scheduleMeeting?.start),
      is_completed: mutatedEntity?.stateId === 'COMPLETED',
      state: mutatedEntity?.stateId === 'COMPLETED' ? 'COMPLETED' : 'OPEN',
    },
    name: mutatedEntity?.name,
    user: {
      name: mutatedEntity?.assigneeId || mutatedEntity?.createdBy,
    },
  }));
